<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12>
        <info-table
          roleLinkField="officialRoles"
          updatePermissions="PROFILE.UPDATE"
          :profile="profile"
          @showEditModal="showEditModal"
        ></info-table>
      </v-flex>
    </v-layout>

    <modal :show="showModal" :id="editId" :edit="!!editId" @close="hideModal" @update="update"></modal>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

import infoTable from '../profile/InfoTable';
import store from '@/store/store';
import Modal from './modals/Manage';
import { modalMixin } from '@/mixins/modal';

/**
 * @vuese
 * Profil
 * @group officials
 */
export default {
  components: { infoTable, Modal },
  mixins: [
    modalMixin('officials', {
      getError: 'Wystąpił błąd podczas pobierania danych urzędnika.',
      updated: 'Zaktualizowano dane urzędnika.',
      updateError: 'Nie udało się zaktualizować danych urzędnika.'
    })
  ],
  props: {
    // id edytowanego profilu jeśli istnieje
    editProfileId: {
      type: Number,
      required: false,
      default: 0
    }
  },
  computed: {
    ...mapState({
      profile: state => state.officials.data.profile,
      id: state => state.officials.data.profile.id
    }),
    editId() {
      if (this.editProfileId) {
        return this.editProfileId.toString();
      } else {
        return this.id.toString();
      }
    }
  }
};
</script>
